export default __webpack_public_path__ + "images/cabin_bag_big.5693850.svg";